import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import useResetPassword from "../../api/hooks/password/useResetPassword";
import Footer from "../../components/Footer";
import CustomInput from "../../components/inputs/CustomInput";
import FeedMessage from "../../components/misc/FeedMessage";
import LogMessage from "../../components/misc/LogMessage";
import { toAssets, toIllustrations } from "../../consts/Paths";
import { authInputs } from "../../consts/inputs";
import { logMsgBgColors } from "../../consts/misc";
import useIsMobile from "../../hooks/useIsMobile";
import useLogMessage from "../../hooks/useLogMessage";
import "../../styles/Access.css";
import "../../styles/General.css";
import { getInputs } from "../../utils/getMethods";
import { validatePassword } from "../../utils/validations";

const ResetPasswordPage = (props: any) => {
  const { isMobile } = useIsMobile();
  const { resetPasswordResponse, resetPasswordResult, resetPassword } =
    useResetPassword();
  const { isToggled, message, write } = useLogMessage();

  const resetForm = useForm();

  const [tempToken, setTempToken] = useState<string | null>(null);
  const [email, setEmail] = useState<string | null>(null);

  useEffect(() => {
    const url = new URL(window.location.href); 
    const tToken = url.searchParams.get("token");
    const tEmail = url.searchParams.get("email");
    /* console.log(tToken, tEmail); */
    if (tToken) {
      setTempToken(tToken);
      setEmail(tEmail);
    } else if (!tToken && window.location.pathname === `/resetpassword`) {
       window.location.href = window.location.origin + "/login" 
    }
  }, []);

  useEffect(() => {
    /* console.log(resetPasswordResponse, resetPasswordResult);   */
    if (resetPasswordResponse?.ok === false) {
      write(
        "subject",
        `Error code: ${resetPasswordResponse.status} ${
          resetPasswordResult?.msg && `: ${resetPasswordResult.msg}`
        }`
      );
      write("bgColor", logMsgBgColors.error);
    }
  }, [resetPasswordResponse]);

  const onSubmit = (data: any) => {
    const objToSend = {
      email: email,
      token: tempToken,
      password: data.new_password,
      password_confirmation: data.confirmed_new_password,
    };
    const validation = validatePassword(
      data.new_password,
      data.confirmed_new_password
    );
    const validationMsg = validation?.msg;
    const isPasswordValid = validation?.isValid;
    if (isPasswordValid) {
      resetPassword(objToSend);
    } else {
      write("subject", validationMsg!);
      write("bgColor", logMsgBgColors.error);
    }
  };

  const chosenInputs = getInputs(authInputs, [
    "new_password",
    "confirmed_new_password",
  ]);
  const renderInputs = chosenInputs.map((input, key) => {
    return (
      <CustomInput
        key={key}
        width={isMobile ? 305 : 460}
        {...input}
        register={resetForm.register}
        errors={resetForm.formState.errors}
      />
    );
  });

  /* useEffect(() => {
    console.log(resetPasswordResponse, resetPasswordResult);
  }, [resetPasswordResponse]);   */

  return (
    <div className="access-background">
      <img className="Logo_2-POS4x" src={`${toAssets}/Logo_2-POS@4x.png`} />
      {resetPasswordResponse?.ok ? (
        <FeedMessage
          imageBgClassName="mailImage-background"
          imageSrc={`${toIllustrations}/congrats.svg`}
          title="E-mail sent"
          description={`You have successfully reset your password`}
          link={{ path: "/login", text: "Return to Log In" }}
        />
      ) : (
        <div className={`access-content-box ${isMobile && "a-c-b-Mob"}`}>
          <div className="access-content-box-inner-wrapper">
            <form onSubmit={resetForm.handleSubmit(onSubmit)}>
              <div className="access-contentBox-header">
                <div className="cornerTitle">
                  {"Reset password"}
                  <p className="cornerSubTitle">Enter the new password</p>
                </div>
              </div>
              <div
                className="input-positioner"
                style={{ gap: "32px", marginTop: "26px" }}
              >
                {renderInputs}
              </div>
              <div
                className="contentBox-confirmationBox"
                style={{ marginTop: "52px" }}
              >
                <span></span>
                <button className="button1 b-short" type="submit">
                  <p className="button1-text">{"Reset"}</p>
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
      {isToggled && (
        <LogMessage
          text={{
            subject: message.subject,
            other_text: message.other_text,
            complement: message.complement,
          }}
          bgColor={message.bgColor}
        />
      )}
      <Footer />
    </div>
  );
};
export default ResetPasswordPage;
